// removed by extract-text-webpack-plugin
module.exports = {"segment-container":"_14ti5rZ47R02moFyDzQtYB","segment-label":"_1DddMNrQHayvUTdyGmks9j","segment-name":"_23Ay0dMX2impslLh73d-8T","active":"pi8FI-eZjiSXySdqoPENO","background-highlight":"_3u4cr3Y84chWnp_HW7k934","spin":"_4_ZZCg6obkNxbOrgNGRGg"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/Action/SegmentButton/styles.scss
// module id = 923
// module chunks = 18